import {inject, Injectable} from '@angular/core';
import {ErrorService} from "../../../services/error.service";
import {RecordTableAction} from "../../../types/record-table-action.types";

@Injectable({
  providedIn: 'root'
})
export class RecordsTableToolbarService {
  private errorService: ErrorService = inject(ErrorService);

  public validateAction(action: RecordTableAction, selectedRowId: number | null): boolean {
    switch(action) {
      case 'ADD_ADVERTISEMENT_PACKAGE':
      case 'VIEW_BLOGGER_GROUPS':
      case 'PRICE_LEVEL_CONFIG_COPY':
      case 'RRC_LIMIT_COPY':
        if (!selectedRowId) {
          const message: Record<string, string> = {
            ADD_ADVERTISEMENT_PACKAGE: 'Выберите рекламу',
            VIEW_BLOGGER_GROUPS: 'Выберите блогера',
            PRICE_LEVEL_CONFIG_COPY: 'Выберите запись',
            RRC_LIMIT_COPY: 'Выберите запись'
          };

          this.errorService.showErrorMessage(message[action]);
          return false;
        }

        break;
      case 'LINE_CHART':
      case 'SETTINGS_TABLE':
        return true;
    }

    return true;
  }
}
